import { createFileRoute } from "@tanstack/react-router";
import { DocsViewer } from "../teacher/documents";

export const Route = createFileRoute("/student/documents")({ component: () => <DocsViewer portal="student" /> });
